import apiClient from './apiClient';

export async function matchCandidates(jobDescription) {
  
  // Production endpoint base URL
  const baseUrl = "https://candidate-matcher-prod-194126254542.us-central1.run.app";
  // Appending the API path consistent with previous versions
  const endpoint = `${baseUrl}/api/match-candidates`;
  
  const { auth } = await import('../firebase/firebase');
  const token = await auth.currentUser?.getIdToken();
  if (!token) {
    throw new Error('User not authenticated.');
  }

  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify({ job_description: jobDescription })
  });

  if (!response.ok) {
    // Capture the raw response text to debug the 500 error
    const errorText = await response.text();
    let errorMessage = `API request failed with status ${response.status}`;
    
    try {
        // Try to parse it as JSON if the server returned a structured error
        const errorJson = JSON.parse(errorText);
        if (errorJson.message) errorMessage = errorJson.message;
    } catch (e) {
        // If not JSON, use the raw text (useful for stack traces or server default error pages)
        if (errorText) errorMessage += `: ${errorText.substring(0, 100)}...`;
    }

    console.error("Match Candidates API Error Details:", { 
        status: response.status, 
        statusText: response.statusText,
        body: errorText 
    });
    
    throw new Error(errorMessage);
  }

  return response.json();
}